export { ProfessorImpactForm } from "./ProfessorImpactForm";
export { ProfessorImpactDialogButton } from "./ProfessorImpactDialogButton";
export type { ProfessorImpactFormProps } from "./ProfessorImpactForm";
export type { ProfessorImpactPayload } from "./types";
